import React, { useEffect } from 'react';
import styled from 'styled-components/macro';
import { space, layout } from 'styled-system';
import { animated } from 'react-spring';

import { Text, Heading2 } from '../SubComponents/Text';
import useWindowSize from '../Hooks/useWindowSize';
import useDragable from '../Hooks/useDragable';

const offset = 50;

const boxShadow = '0 4px 6px rgba(50, 50, 93, 0.15), 0 1px 3px rgba(0, 0, 0, 0.1)';

interface SummaryBoxProps {
  top: number;
}

const SummaryBox = styled.div.attrs<SummaryBoxProps>((props) => {
  return { top: props.top - offset };
})<SummaryBoxProps>`
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props.theme.colors.summaryBackgroundColor};
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
  box-shadow: ${(props) => (props.theme.shadows ? boxShadow : 'none')};
  text-align: center;
  position: fixed;
  left: 2.5%;
  right: 2.5%;
  z-index: 100;
  padding: 17px 20px ${(props) => props.top}px;
  margin: 0;
  top: ${(props) => props.top}px;
  touch-action: none;
  will-change: transform;

  ${space}
  ${layout}
`;

const Grabber = styled.div`
  display: flex;
  text-align: center;
  justify-content: center;
  margin: -17px -20px -29px;
  padding-top: 8px;
  height: 50px;
`;

const GrabHandle = styled.div`
  background-color: #fff;
  width: 35px;
  height: 4.5px;
  border-radius: 3px;
  pointer-events: none;
`;

const getTransform = (position: any) =>
  position.interpolate((y: number) => `translateY(${y}px)`);

interface SummaryMobileProps {
  children?: React.ReactNode;
  heading: string;
  shopName?: string;
  isSummaryOpen: boolean;
  setSummaryOpen: (isOpen: boolean) => void;
}

const SummaryMobile = (props: SummaryMobileProps) => {
  const { height: windowHeight } = useWindowSize();
  const { bind, ref, position, isOpen, setOpen, setClosed } = useDragable();

  console.log('summary mobile,', props);

  // Bind the drag gesture to the summary component
  useEffect(() => {
    bind();
  }, [bind]);

  // Sync isOpen and props.isSummaryOpen
  useEffect(() => {
    if (props.isSummaryOpen !== isOpen) {
      props.setSummaryOpen(isOpen);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  useEffect(() => {
    if (props.isSummaryOpen !== isOpen) {
      props.isSummaryOpen ? setOpen() : setClosed();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isSummaryOpen]);

  return (
    <SummaryBox
      ref={ref}
      top={windowHeight}
      as={animated.div}
      style={{ transform: getTransform(position) }}
    >
      <Grabber id="grabber">
        <GrabHandle />
      </Grabber>

      <Heading2 pointerNone color="#fff" mb="2">
        {props.heading}
      </Heading2>

      <Text color="#fff" mb="3">
        {props.shopName}
      </Text>

      {props.children}
    </SummaryBox>
  );
};

export default SummaryMobile;
